<template>
  <TabGroup
    @change="tabChangeHandler"
    :selectedIndex="selectedTabIndex"
  >
    <slot></slot>
  </TabGroup>
</template>

<script setup>
import { onMounted, provide, ref, inject } from 'vue'
import { TabGroup } from '@headlessui/vue'
import { PAGE_TABS_COMPONENT, PAGE_URL_PARAMS } from '@/utils/symbols'

const TAB_QUERY_PARAM = 'tab'

const selectedTabIndex = ref(0)

const urlParams = inject(PAGE_URL_PARAMS)

/**
 * @typedef {Object} Tab
 * @property {string} key - The unique key of the tab.
 */

/**
 * @type {import('vue').Ref<Tab[]>}
 */
const tabs = ref([])

const pageTabs = {
  registerTab: (tab) => {
    if (!tab.key) {
      throw new Error('Tab must have a key.')
    }
    tabs.value.push(tab)
  }
}

provide(PAGE_TABS_COMPONENT, pageTabs)

function tabChangeHandler(index) {
  selectedTabIndex.value = index
  const selectedTab = tabs.value[index]
  urlParams[TAB_QUERY_PARAM] = selectedTab.key
}

onMounted(() => {
  const currentTabKey = urlParams[TAB_QUERY_PARAM]

  if (!currentTabKey) {
    return
  }

  selectedTabIndex.value = tabs.value.findIndex((tab) => tab.key === currentTabKey)
})
</script>
